import { Grid } from "@mui/material";
//@ts-ignore
import styles from "./LoggedInPageTemplate.module.scss";

interface LoggedInPageTemplateProps {
	children: JSX.Element;
}

const LoggedInPageTemplate: React.FC<LoggedInPageTemplateProps> = ({ children }) => {
	return (
		<>
			<Grid container className={styles.LoggedInPageTemplate}>
				<Grid item xs={12} style={{ width: "100%", height: "calc(100vh - 20px)", minHeight: "calc(100vh - 20px)" }}>
					{children}
				</Grid>
			</Grid>
		</>
	);
};

export default LoggedInPageTemplate;
